import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/helpers/event-bus.js